import classNames from 'classnames';
import ProductFeature from 'components/gruenland/atoms/product/ProductFeature';
import { useFormat } from 'helpers/hooks/useFormat';
import { TYPOGRAPHY_PRODUCT_DETAIL_TITLE } from 'lib/typography';

type Props = {
  items?: Record<string, string>;
  className?: string;
};

const whitelist = [
  'brand',
  'family',
  'fit',
  'gender',
  'heel',
  'insole',
  'lining',
  'madeIn',
  'manufacturer',
  'material',
  'outsole',
  'typology',
  'weight',
];

const orderedItems = ['material', 'lining', 'insole', 'outsole'];

const Features: React.FC<Props> = ({ items, className }) => {
  const { formatMessage } = useFormat({ name: 'gruenland' });

  if (!items) return null;

  const orderedFeatures = orderedItems.map((x) => Object.keys(items).includes(x) && x);
  const features = orderedFeatures.concat(
    Object.keys(items)
      .filter((x) => !orderedItems.includes(x))
      .filter((x) => whitelist.includes(x)),
  );

  return (
    <div id="pdpFeatures" className={className}>
      <h2 className={classNames(TYPOGRAPHY_PRODUCT_DETAIL_TITLE, 'text-center')}>
        {formatMessage({ id: 'product.features', defaultMessage: 'Caratteristiche' })}
      </h2>
      <div className="mt-10 grid w-full grid-cols-2 gap-6 lg:grid-cols-4 lg:gap-[60px]">
        {features.map(
          (x, i) =>
            x && (
              <ProductFeature feature={x} key={i}>
                {items[x]}
              </ProductFeature>
            ),
        )}
      </div>
    </div>
  );
};

export default Features;
